'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 服务变更活动
 * 
 * @export
 * @class ServiceAction
 */
var ServiceAction =

/**
 * 创建活动
 * 
 * @ignore
 * @param {string} action 
 * @memberof ServiceAction
 */

/**
 * 增加
 * 
 * @type ServiceAction
 * @static
 * @memberof ServiceAction
 */
function ServiceAction(action) {
  (0, _classCallCheck3.default)(this, ServiceAction);

  this.action = action;
  (0, _freeze2.default)(this);
}

/**
 * 枚举值
 * 
 * @type {ServiceAction[]}
 * @static
 * @memberof ServiceAction
 */

/**
 * 删除
 * 
 * @type ServiceAction
 * @static
 * @memberof ServiceAction
 */
;

ServiceAction.ADDED = new ServiceAction('added');
ServiceAction.REMOVED = new ServiceAction('removed');

ServiceAction.values = function () {
  var enumValues = [];
  enumValues.push(ServiceAction.ADDED);
  enumValues.push(ServiceAction.REMOVED);
  return enumValues;
};

exports.default = ServiceAction;


(0, _freeze2.default)(ServiceAction);
//# sourceMappingURL=ServiceAction.js.map